exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-07217fb7] .cc-field {\n  max-height: 32px;\n  width: 100%;\n}\n[data-v-07217fb7] .cc-field iframe {\n  height: 32px !important;\n}\n.cc_icons[data-v-07217fb7] {\n  overflow: hidden;\n  margin-left: 10px;\n}\n.cc_icons .v-image[data-v-07217fb7] {\n  width: 32px;\n  height: 20px;\n  float: left;\n  margin-top: 0;\n  margin-bottom: 10px;\n  margin-right: 10px;\n}\n@media screen and (min-width: 600px) {\n.cc_icons .v-image[data-v-07217fb7] {\n    margin-top: 22px;\n    margin-bottom: 0;\n}\n}\n", ""]);

// exports
